import React, { useEffect } from "react";
import { connect } from "react-redux";
import Input from "../componentes/Input.jsx";
import ButtonLogin from "../componentes/ButtonLogin.jsx";
import Api from "../../utils/Api.jsx";
import "./estilo_recuperarSenha.css";

function NovaSenha() {
  const [id_usuario, setIdUsuario] = React.useState("");
  const [emailUser, setEmailUser] = React.useState("");
  const [senha1, setSenha1] = React.useState("");
  const [senha2, setSenha2] = React.useState("");
  const [validaSenha, setValidaSenha] = React.useState(false);
  const [validaBotao, setValidaBotao] = React.useState(false);
  const [validaForm, setValidaForm] = React.useState(true);
  const [msgErro, setMsgErro] = React.useState("");
  const [msgSucesso, setMsgSucesso] = React.useState("");

  function pegaTokenGravadoUrl() {
    const url = window.location.href.split("?");
    return url[1];
  }

  async function validaToken() {
    const ret = await Api.buscar("valida_token", "", pegaTokenGravadoUrl());
    if (ret.dados.length > 0) {
      setIdUsuario(ret.dados[0].id_pk);
      setEmailUser(ret.dados[0].email);
      setValidaForm(true);
    } else {
      setValidaForm(false);
    }
    return ret;
  }

  async function aleteraSenha() {
    const ret = await Api.buscar("insere_nova_senha", "", getRegistro());
    setMsgSucesso("Senha alterada com sucesso!");
    setValidaSenha(true);
    return ret;
  }

  useEffect(() => {
    if (senha1 === senha2 && senha1.length > 7) {
      setValidaBotao(true);
    } else {
      if (senha1.length > 7) {
        if (senha1.length == senha2.length) {
          setMsgErro("As senhas não conferem");
        } else {
          setMsgErro("");
        }
      }
      setValidaBotao(false);
    }
  }, [senha1, senha2]);

  useEffect(() => {
    pegaTokenGravadoUrl();
    validaToken();
  }, []);

  function redireciona() {
    window.location.href = "/login";
  }

  return (
    <div>
      <div className="blocoLogin3">
        <div className="apiceStart">
          <div className="apiceStart-icon">
            <i className={"fa rxzz " + global.app.icone} />
          </div>
          <div className="apiceStart-titulo">
            <b>ERP-BI</b>
          </div>
        </div>
        {validaForm ? (
          <div className="loginBox">
            <h2 className="loginBoxMsg">Crie uma nova senha</h2>
            <form>
              <div className="blocoInput">
                <Input
                  className="inputEmail"
                  placeholder="Insira sua senha"
                  uppercase={false}
                  disabled={validaSenha}
                  value={senha1}
                  type="password"
                  onChange={(e) => setSenha1(e.target.value)}
                />
              </div>
              <div className="blocoInput">
                <Input
                  className="inputEmail"
                  placeholder="Confirme sua senha"
                  uppercase={false}
                  disabled={validaSenha}
                  value={senha2}
                  type="password"
                  onChange={(e) => setSenha2(e.target.value)}
                />
              </div>
              <div className="blocoBotao">
                {!msgSucesso ? (
                  <div className="blocoBotao">
                    {!validaBotao || validaSenha ? (
                      <ButtonLogin
                        className="botaoEnviar2"
                        label="Nova senha"
                        disabled
                      />
                    ) : (
                      <ButtonLogin
                        className="botaoEnviar"
                        onClick={() => aleteraSenha()}
                        label="Nova senha"
                      />
                    )}
                  </div>
                ) : (
                  <ButtonLogin
                    className="botaoEnviar"
                    onClick={() => redireciona()}
                    label="Ir para tela de login"
                  />
                )}
              </div>
              <br />
              {msgErro && (
                <div className="blocoMsgErro">
                  <div className="msgErroRs">{msgErro}</div>
                </div>
              )}
              {msgSucesso && (
                <div className="blocoMsgSucesso">
                  <div className="msgSucesso">{msgSucesso}</div>
                </div>
              )}
            </form>
          </div>
        ) : (
          <div>
            <div className="divisaoMsgErroToken" />
            <div className="blocoMsgErroTn">
              <div className="msgErroTn">
                <b>Token inválido ou expirado!</b>
                <br />
              </div>

              <div className="msgErroTn2">
                Gere um novo link de recuperação de senha no botão abaixo.
              </div>
            </div>
            <div className="blocoBotao4">
              <a href="../recuperarsenha">
                <ButtonLogin className="botaoEnviar" label="Gerar novo link" />
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );

  function getRegistro() {
    return {
      id_usuario: id_usuario,
      senha: senha1,
      emailUser: emailUser,
    };
  }
}

export default connect((state) => ({ usuario: state.usuario }))(NovaSenha);



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/main/NovaSenha.jsx